import ApiClient from './apiClient'
import {
  SearchRequestParams,
  SearchResponseParams,
  GetKeywordRequestParams,
  KeywordParam,
  PostSearchConditionParams,
  PatchSearchConditionParams,
} from '../types/search'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSearchResult = async (params: SearchRequestParams): Promise<any> => ApiClient.get(
  '/api/search/result',
  (result: SearchResponseParams) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSearchHistoryList = async (): Promise<any> => ApiClient.get(
  '/api/search/history',
  (result: string[]) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSearchKeywordList = async (params :GetKeywordRequestParams): Promise<any> => ApiClient.get(
  '/api/search/keyword',
  (result: KeywordParam[]) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSearchConditionList = async (): Promise<any> => ApiClient.get(
  '/api/search/condition',
  (result: string[]) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postSearchConditionList = async (params :PostSearchConditionParams): Promise<any> => ApiClient.post(
  '/api/search/condition',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchSearchConditionList = async (params :PatchSearchConditionParams): Promise<any> => ApiClient.patch(
  `/api/search/condition/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteSearchConditionList = async (params :number): Promise<any> => ApiClient.delete(
  `/api/search/condition/${params}`,
  () => {
    // do nothing
  },
  params,
)
